/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Portal_DescInputs */

const en_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const de_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde Adzuna, Jooble und Arbeitnow. KI scannt alle drei in Echtzeit, dedupliziert Angebote und zeigt die besten Matches für dein Profil.`)
};

const fr_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const es_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const it_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const nl_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const pl_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const fi_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const da_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

const sv_landing_tab_portal_desc = /** @type {(inputs: Landing_Tab_Portal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile.`)
};

/**
* | output |
* | --- |
* | "Connect Adzuna, Jooble, and Arbeitnow. AI scans all three in real-time, deduplicates listings, and surfaces the best matches for your profile." |
*
* @param {Landing_Tab_Portal_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_portal_desc = /** @type {((inputs?: Landing_Tab_Portal_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Portal_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_portal_desc(inputs)
	if (locale === "fr") return fr_landing_tab_portal_desc(inputs)
	if (locale === "es") return es_landing_tab_portal_desc(inputs)
	if (locale === "it") return it_landing_tab_portal_desc(inputs)
	if (locale === "nl") return nl_landing_tab_portal_desc(inputs)
	if (locale === "pl") return pl_landing_tab_portal_desc(inputs)
	if (locale === "fi") return fi_landing_tab_portal_desc(inputs)
	if (locale === "da") return da_landing_tab_portal_desc(inputs)
	if (locale === "sv") return sv_landing_tab_portal_desc(inputs)
	return en_landing_tab_portal_desc(inputs)
});